import { Component, OnInit } from '@angular/core';
import { AccountService } from '../../../_services/account.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from "@angular/forms";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountImport } from '../../../_models/index';
import { CustomerService, ProcessService, ConfigurationService } from '../../../_services/index';
import { BatchProcessUrls } from '../../../_enums/urls';
import * as fs from 'file-saver';
import * as moment from 'moment';
import { version } from 'src/app/_enums/version.enum';

@Component({
  selector: 'app-old-process-import',
  templateUrl: './processimport.component.html',
  styleUrls: ['../../../../assets/css/customer-list-table.css']
})
export class ProcessOperationbankImport implements OnInit {

  customerPuplic_key: any;
  user_public_id: any;
  data: any;
  excelHeader: any;
  uploadedFileName: any;
  enableImportTxt: boolean = true;

  enableImportConfirm: boolean;
  fileID: string;
  formData: FormData = new FormData();
  searchFilterForm: FormGroup;
  enableEdit: boolean = true;
  tab1ActiveStatus: any;
  tab2ActiveStatus: any;
  tab3ActiveStatus: any;
  tab1Visibility: any;
  tab2Visibility: any;
  tab3Visibility: any;
  txtProcessStatus: any;
  ProcessTitle: any;
  ProcessSubTitle: any;
  processErrorDetails: any;
  customer_Account_public_id: any;
  subscriptionId: any;
  apiKey: any;
  userAuth: any = [];
  userNameProcess: any;
  userEmail: any;

  btnProx: boolean = true;
  btnRegre: boolean = false;

  resultData: any;
  totalRecords: any;
  parseID: any;

  configData: any;
  templateName: any;
  kashioApplication: any;
  public tFileList: File;
  designVersion: string;
  isV2Template: boolean = false;
  uploadedFileType: string;
  presignedUrl: string;

  constructor
    (
      private router: Router
      , private spinnerService: Ng4LoadingSpinnerService
      , private accountService: AccountService
      , private activatedRoute: ActivatedRoute
      , private formBuilder: FormBuilder
      , private customerservice: CustomerService
      , private processservice: ProcessService
      , private configurationService: ConfigurationService
    ) {


  }//end const

  ngOnInit() {

    if (
      (localStorage.getItem('companyId') != null || localStorage.getItem('companyId') != '' || localStorage.getItem('companyId') != undefined)
      &&
      (localStorage.getItem('application') != null || localStorage.getItem('application') != '' || localStorage.getItem('application') != undefined)) {
      if (localStorage.getItem('isCorporate') == 'Yes') {
        this.customerPuplic_key = localStorage.getItem('subcompanyId');
      } else {
        this.customerPuplic_key = localStorage.getItem('companyId');
      }
      this.user_public_id = localStorage.getItem('userId');
      this.userNameProcess = localStorage.getItem('username');
      this.userEmail = localStorage.getItem('userEmail');
    }
    else {
      this.router.navigate(['/home']);
    }

    this.designVersion = localStorage.getItem('designVersion');
    this.kashioApplication = localStorage.getItem('application');
    this.enableImportConfirm = false;
    this.GetConfigList();

    this.searchFilterForm = this.formBuilder.group({
      edt: ['']
    });

    this.GetCustomerApiDetails();
    this.tab1ActiveStatus = "active";
    this.tab2ActiveStatus = "disabled";
    this.tab3ActiveStatus = "disabled";
    this.tab1Visibility = true;
    this.tab2Visibility = false;
    this.tab3Visibility = false;
    this.uploadedFileName = "Archivo a subir";
  }

  /***Get Configuration List */
  GetConfigList() {

    this.configurationService.getConfigurationList(this.customerPuplic_key, 'KBATCH').subscribe(data => {
      this.configData = data["data"];

      this.isV2Template = this.configData.some((item) => item.values && item.values.version && item.values.version.toUpperCase() === version.V2);

      if (this.configData.length != 0) {
        this.templateName = this.configData[0].values.value;
      }
    },
      error => {
        console.log('Failed! while trying to get the acccount details list. ' + error.error);
      });

  }

  downloadSampleFile() {
    //location.href = "assets/helpfiles/PAYMENTS_XLS_CORP.xlsx";
    var url = 'assets/helpfiles/PAYMENT_XLS_CORP.xlsx?v=' + moment(new Date()).format('YYYYMMDDHHmm');
    var fileName = "PAYMENT_XLS_CORP.xlsx";
    this.customerservice.downloadTemplatefile(url).subscribe(res => {
      var blob = new Blob([res.body], { type: res.body.type });
      const file = new File([blob], fileName, { type: res.body.type });
      fs.saveAs(file);
    },
      error => {
        console.log('Failed while trying to the download the file. ' + error.error);
      })
  }

  GetCustomerApiDetails() {

    this.customerservice.getApiDetails(this.customerPuplic_key).subscribe(data => {
      if (data.value != 'undefined') {
        this.apiKey = data.value;
      }
    },
      error => {
        console.log('Failed! while trying to get the acccount details list. ' + error.error);
      });
  }//end

  onFileChange(event: any) {
    this.spinnerService.show();
    this.processErrorDetails = "";
    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length > 1) throw new Error('Cannot use multiple files');
    // if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    if (target.files.length === 1) {
     // this.uploadedFileName = target.files[0].name;
      if(
        (target.files[0].name.includes(".txt") && (target.files[0].type == ".txt" || target.files[0].type == "text/plain")) ||
        ((target.files[0].name.includes(".xlsx") ||  target.files[0].name.includes(".xls") )&& (target.files[0].type == ".xlsx" || target.files[0].type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || target.files[0].type == "application/vnd.ms-excel")) ||
        (target.files[0].name.includes(".csv") && (target.files[0].type == "text/csv" || target.files[0].type == "application/vnd.ms-excel"))
        ) {
        this.enableImportTxt = false;
        this.uploadedFileName = event.target.files[0].name;
        const file = event.target.files[0];
        this.tFileList = event.target.files[0];
        this.uploadedFileType = file.type;
        this.searchFilterForm.get('edt').setValue(file);
      }
      else {
        this.enableImportTxt = true;
        this.processErrorDetails = "Please select .txt or .csv or .xls or .xlsx file only!";
      }
    }
    this.spinnerService.hide();

  }


  importExcelData(event, { value }: { value: AccountImport }) {
    this.spinnerService.show();
    this.enableImportTxt = true;

    if (!this.isV2Template) {
      this.executeCurrentFlow(value);
    } else {
      this.executeNewFlow(value);
    }
  }

  executeCurrentFlow(value: AccountImport) {
    var json_data: any = {
      "user":
        { "id": `${this.user_public_id}`, "name": `${this.userNameProcess}`, "email": `${this.userEmail}` },
      "company":
        { "id": `${this.customerPuplic_key}`, "name": `${this.userNameProcess}` }
    };

    if(value.edt.name.includes(".txt") && (value.edt.type == ".txt" || value.edt.type == "text/plain") ){
      this.formData.append('edt', new Blob([this.searchFilterForm.get('edt').value], { type: "text/plain;charset=iso-8859-1" }), this.uploadedFileName);
    }
    else if((value.edt.name.includes(".xlsx") ||  value.edt.name.includes(".xls") )&& (value.edt.type == ".xlsx" || value.edt.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || value.edt.type == "application/vnd.ms-excel")){
      this.formData.append('edt', new Blob([this.searchFilterForm.get('edt').value], { type: "application/vnd.ms-excel" }), this.uploadedFileName);
    }
    else if(value.edt.name.includes(".csv") && (value.edt.type == "text/csv" || value.edt.type == "application/vnd.ms-excel")){
      this.formData.append('edt', new Blob([this.searchFilterForm.get('edt').value], { type: "text/csv" }), this.uploadedFileName);
    }
   // this.formData.append('edt', this.searchFilterForm.get('edt').value);

    this.formData.append('description', "EDT FILE");
    this.formData.append('customer_id', this.customerPuplic_key);
    this.formData.append('template', this.templateName);
    this.formData.append('metadata', JSON.stringify(json_data))

    this.processservice.ProcessImport(this.formData).subscribe(val => {
      this.btnProx = false;

      this.resultData = val;

      const hasBody = val && val.body;
      const returnedId = hasBody ? val.body.id : null;

      if (!returnedId) {
        this.tab1ActiveStatus = "disabled";
        this.tab2ActiveStatus = "active";
        this.tab3ActiveStatus = "disabled";
        this.tab1Visibility = false;
        this.tab2Visibility = true;
        this.tab3Visibility = false;
        this.enableEdit = false;
        this.ProcessTitle = "Problema en el procesamiento del archivo";
        this.ProcessSubTitle = "El archivo se cargó correctamente, pero ocurrió un inconveniente durante su procesamiento.\nPor favor, contacta a soporte para revisar el caso.";
        
        return;
      }

      this.parseID = returnedId;
      if (val.status == '200') {

        this.tab1ActiveStatus = "disabled";
        this.tab2ActiveStatus = "active";
        this.tab3ActiveStatus = "disabled";
        this.tab1Visibility = false;
        this.tab2Visibility = true;
        this.tab3Visibility = false;
        this.totalRecords = hasBody && this.resultData.body.total_records != null ? this.resultData.body.total_records : "";

        this.ProcessTitle = "Archivo ha sido leído correctamente";
        this.ProcessSubTitle = "Total registros leídos :";
        this.spinnerService.hide();
      }
      else {
        this.tab1ActiveStatus = "disabled";
        this.tab2ActiveStatus = "active";
        this.tab3ActiveStatus = "disabled";
        this.tab1Visibility = false;
        this.tab2Visibility = true;
        this.tab3Visibility = false;
        this.enableEdit = false;
        this.ProcessSubTitle = "Error al intentar procesar el archivo !";
        this.spinnerService.hide();
      }
    },
      err => {

        this.tab1ActiveStatus = "disabled";
        this.tab2ActiveStatus = "active";
        this.tab3ActiveStatus = "disabled";
        this.tab1Visibility = false;
        this.tab2Visibility = true;
        this.tab3Visibility = false;
        this.enableEdit = false;
        this.ProcessSubTitle = "Error al intentar procesar el archivo !";
        this.spinnerService.hide();
      });
  }

  executeNewFlow(value: AccountImport) {
    const file_name  = this.uploadedFileName;
    const file_type = this.uploadedFileType;
    const user_id = this.user_public_id;
    const user_name = this.userNameProcess;
    const user_email = this.userEmail;
    const company_id = this.customerPuplic_key;

    const uploadPayload: any = {
      user_id: user_id,
      user_name: user_name,
      user_email: user_email,
      company_id: company_id,
      file_name: file_name,
      file_type: file_type
    };

    if (this.kashioApplication) {
      uploadPayload.service_name = this.kashioApplication;
    }

    this.processservice.uploadFileToKbatch(uploadPayload).subscribe(
      (response) => {
        if (response && response.data && response.data.file_id) {
          localStorage.setItem('file_id', response.data.file_id);
        }

        if (response && response.data && response.data.presigned_url) {
          this.presignedUrl = response.data.presigned_url;
          if (this.tFileList) {
            this.processservice.uploadFileToPresignedUrl(this.presignedUrl, this.tFileList).subscribe(
              (putResponse) => {
                this.btnProx = false;
                this.tab1ActiveStatus = "disabled";
                this.tab2ActiveStatus = "active";
                this.tab3ActiveStatus = "disabled";
                this.tab1Visibility = false;
                this.tab2Visibility = true;
                this.tab3Visibility = false;
                this.ProcessTitle = "Archivo ha sido leído correctamente";
                this.spinnerService.hide();
              },
              (putError: any) => {
                this.tab1ActiveStatus = "disabled";
                this.tab2ActiveStatus = "active";
                this.tab3ActiveStatus = "disabled";
                this.tab1Visibility = false;
                this.tab2Visibility = true;
                this.tab3Visibility = false;
                this.enableEdit = false;
                this.ProcessSubTitle = "Error al intentar procesar el archivo !";
                this.spinnerService.hide();
              }
            );
          } else {
            this.tab1ActiveStatus = "disabled";
            this.tab2ActiveStatus = "active";
            this.tab3ActiveStatus = "disabled";
            this.tab1Visibility = false;
            this.tab2Visibility = true;
            this.tab3Visibility = false;
            this.enableEdit = false;
            this.ProcessSubTitle = "Error al intentar procesar el archivo !";
            this.spinnerService.hide();
          }
        } else {
          this.tab1ActiveStatus = "disabled";
          this.tab2ActiveStatus = "active";
          this.tab3ActiveStatus = "disabled";
          this.tab1Visibility = false;
          this.tab2Visibility = true;
          this.tab3Visibility = false;
          this.enableEdit = false;
          this.ProcessSubTitle = "Error al intentar procesar el archivo !";
          this.spinnerService.hide();
        }
      },
      (error: any) => {
        this.tab1ActiveStatus = "disabled";
        this.tab2ActiveStatus = "active";
        this.tab3ActiveStatus = "disabled";
        this.tab1Visibility = false;
        this.tab2Visibility = true;
        this.tab3Visibility = false;
        this.enableEdit = false;
        this.ProcessSubTitle = "Error al intentar procesar el archivo !";
        this.spinnerService.hide();
      }
    );
  }

  importConfirm() {

    this.enableImportConfirm = true;
    this.spinnerService.show();
    this.fileID = localStorage.getItem('file_id');

    let subscription = null;
    if (this.isV2Template) {
      subscription = this.processservice.ProcessImportConfirm(this.fileID)
    }else{
      // fallback
      subscription = this.processservice.ProcessImportParse(this.parseID)
    }

    subscription.subscribe(val => {

      this.tab1ActiveStatus = "disabled";
      this.tab2ActiveStatus = "disabled";
      this.tab3ActiveStatus = "active";
      this.tab1Visibility = false;
      this.tab2Visibility = false;
      this.tab3Visibility = true;
      if (val == 200) {
        this.ProcessTitle = "Archivo Procesado con éxito!";
      this.ProcessSubTitle = "";
      }
      else {
        this.ProcessTitle = "Archivo está siendo procesado ...";
        this.ProcessSubTitle = this.isV2Template ? "" : "Recibirá un email al finalizar el proceso";
      }
      this.spinnerService.hide();
    },
      err => {
        this.tab1ActiveStatus = "disabled";
        this.tab2ActiveStatus = "active";
        this.tab3ActiveStatus = "disabled";
        this.tab1Visibility = false;
        this.tab2Visibility = true;
        this.tab3Visibility = false;
        this.enableEdit = false;
        this.totalRecords = "";
        this.ProcessTitle = "";
        this.ProcessSubTitle = "Error al intentar procesar el archivo !";
        this.spinnerService.hide();
      });
  }

  removeQueryParamAndRedirect(event: Event) {
    event.preventDefault();
    if (this.designVersion === 'V2') {
      this.navigateToLayout('Proceso por lotes');
    } else {
      this.router.navigate([BatchProcessUrls.URL_BATCHES_V1]);
    }
  }

  navigateToLayout(tabName: string) {
    const config = {
      queryParams: { tabName: tabName }
    };
    this.router.navigate(['/new_configuration_layout'], config);
  }

}
